import React from "react";
import { Helmet } from "react-helmet-async";
import { canonicalUrl } from "../siteConfig";

export default function HowItWorksPage() {
  return (
    <div className="app page-grid">
      <Helmet>
        <title>How OptiSiteSEO Works | Technical Visibility Reports</title>
        <meta
          name="description"
          content="See how OptiSiteSEO turns a URL into a technical SEO and visibility report with discoverability, indexing, crawlability, performance, and measurement signals."
        />
        <link rel="canonical" href={canonicalUrl("/how-it-works")} />
      </Helmet>

      <section className="card section page-hero">
        <p className="eyebrow">How it works</p>
        <h1>From URL to action plan</h1>
        <p className="subtext">
          One minute from paste to prioritized technical SEO and visibility signals. Built so operators see the issue and implementers see what to change.
        </p>
        <div className="cta-row">
          <a className="primary" href="/app/index.html">
            Run Free SEO Scan
          </a>
          <a className="secondary" href="/demo/index.html">
            See a sample report
          </a>
        </div>
      </section>

      <section className="card section page-card">
        <h2>Step-by-step</h2>
        <ol className="bullets">
          <li>Enter a URL and start the scan.</li>
          <li>We inspect indexing, crawlability, metadata, OpenGraph, performance risk hints, and basics like robots/sitemap.</li>
          <li>We prioritize issues by business impact and include clear next steps.</li>
        </ol>
      </section>
    </div>
  );
}
